module.exports = __webpack_public_path__ + "img/spotify-brands.f458035.svg";